import { IOrderItem } from '../../model/order.store'
import { mooncake2025SingleSkus, mooncakeGiftBoxSkus } from '../skus.utils'

/**
 * Chương trình khuyến mãi bánh trung thu 2025
 * - Giảm giá theo số lượng (bundled sales)
 * - Tặng hộp con cho đơn bánh lẻ
 */

// ============================================
// BUNDLED SALES - Giảm giá theo số lượng
// ============================================
export function getMooncakeBundledSalesByType(type: string) {
  if (type === 'set4') {
    return [
      {
        quantity: 3,
        discount: 5
      },
      {
        quantity: 6,
        discount: 10
      },
      {
        quantity: 11,
        discount: 15
      },
      {
        quantity: 21,
        discount: 20
      },
      {
        quantity: 51,
        discount: 25
      },
      {
        quantity: 101,
        discount: 30
      },
      {
        quantity: 200,
        discount: 35
      },
      {
        quantity: 500,
        discount: 40
      },
      {
        quantity: 1250,
        discount: 45
      }
    ]
  }
  if (type === 'set2') {
    return [
      {
        quantity: 5,
        discount: 5
      },
      {
        quantity: 11,
        discount: 10
      },
      {
        quantity: 21,
        discount: 15
      },
      {
        quantity: 41,
        discount: 20
      },
      {
        quantity: 101,
        discount: 25
      },
      {
        quantity: 201,
        discount: 30
      },
      {
        quantity: 501,
        discount: 35
      },
      {
        quantity: 1250,
        discount: 40
      },
      {
        quantity: 2500,
        discount: 45
      }
    ]
  }
  if (type === 'single') {
    return [
      {
        quantity: 20,
        discount: 5
      },
      {
        quantity: 40,
        discount: 10
      },
      {
        quantity: 100,
        discount: 15
      },
      {
        quantity: 200,
        discount: 20
      },
      {
        quantity: 400,
        discount: 25
      },
      {
        quantity: 1000,
        discount: 30
      },
      {
        quantity: 2000,
        discount: 35
      },
      {
        quantity: 3000,
        discount: 40
      },
      {
        quantity: 5000,
        discount: 45
      }
    ]
  }
  return []
}

// ============================================
// GIFT BOX - Tặng hộp con bánh lẻ
// ============================================
export function checkAndGetValidMooncakeGiftBox(items: IOrderItem[]) {
  // Đếm số lượng bánh trung thu lẻ
  const mooncakeRetailCount = items.reduce((total, item) => {
    // Kiểm tra có phải bánh trung thu lẻ không (dựa vào SKU)
    if (mooncake2025SingleSkus.includes(item.sku)) {
      return total + item.quantity
    }
    return total
  }, 0)

  // Chỉ tặng hộp nếu số lượng bánh lẻ > 0 và < 20
  const isValid = mooncakeRetailCount > 0 && mooncakeRetailCount < 20

  return {
    isValid,
    giftQuantity: isValid ? mooncakeRetailCount : 0,
    giftSkus: mooncakeGiftBoxSkus,
    saleProgram: 'Tặng hộp con trung thu đơn bánh lẻ'
  }
}
